import { Helmet } from "react-helmet";
import NotFoundLayout from "../section/notFound/not-found-layout";

const NotFoundPage = () => {
    <Helmet>
        <title>Page Not Found</title>
    </Helmet>

    return (
        <>
            <NotFoundLayout />
        </>
    );
}

export default NotFoundPage;